import React from 'react';
import { Card, CardContent, Typography, makeStyles } from '@material-ui/core';


const useStyles = makeStyles(() => ({
    card: {
        border: '1px solid #b0b0b0',
        cursor: 'pointer',
        transition: 'transform 0.3s ease-in-out, background-color 0.3s ease-in-out',
        '&:hover': {
            transform: 'scale(1.05)',
        },
    },
    iconContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '20px',
        // height: '150px',
    }
}))

const SingleCard = ({ title, image, isActive, onClick }) => {
    // console.log("-----------SingleCard-----------")
    // console.log({title, image, test})
    // console.log({item})

    const classes = useStyles();

    return (
        <Card onClick={onClick} className={classes.card} style={{borderColor: isActive ? "#f50057" : "#000"}}>
            <CardContent style={{padding: '8px'}}>
                <div style={{ marginBottom: '4'}}>
                    <Typography >{title}</Typography>
                </div>

                <div className={classes.iconContainer} style={{margin: '0px', width: '100%', height: '100px', overflow:'hidden'}}>
                    {image ? (
                        <img
                            src={`${process.env.PUBLIC_URL}/widget_images/${image}.png`}
                            alt={`${title} icon`}
                            style={{ width: '100%' }}
                        />
                    ) : (
                        <div
                            style={{
                                width: '100%',
                                height: '100%',
                                backgroundColor: '#e0e0e0',
                                display: 'inline-block',
                                borderRadius: '80%',
                            }}
                        >
                        </div>
                    )}
                </div>
            </CardContent>
        </Card>
    );
};

export default SingleCard;
